import {useRef} from 'react';

// Respond to a completed touch immediately. Some mobile browsers omit the
// compatibility click following a canvas gesture; late clicks must not undo twice.
export default function HistoryButton({onClick,children,...props}) {
 const touch=useRef(null),ignoreClickUntil=useRef(0);
 return <button {...props}
  onPointerDown={e=>{touch.current=e.pointerType==='touch'?{id:e.pointerId,x:e.clientX,y:e.clientY}:null;if(e.pointerType!=='touch')ignoreClickUntil.current=0;}}
  onPointerCancel={()=>{touch.current=null;}}
  onPointerUp={e=>{
   const start=touch.current;touch.current=null;
   if(!start||start.id!==e.pointerId||Math.hypot(e.clientX-start.x,e.clientY-start.y)>8)return;
   ignoreClickUntil.current=performance.now()+650;onClick(e);
  }}
  onClick={e=>{if(e.detail!==0&&performance.now()<ignoreClickUntil.current)return;onClick(e);}}
 >{children}</button>;
}
